import { inject } from '@angular/core';
import { ConfigService, IAssessmentConfig } from '@upmc-healthplan-npm/assessments';
import { OidcClientService } from '@upmc-healthplan-npm/oidc-client';
import { API_CONFIG } from 'app/api-config/api-config';
import { IApiConfig } from 'app/interfaces';
import { AssessmentsService } from './services/assessments.service';

export function resolveAssessments(): IAssessmentConfig {
  const user = inject(OidcClientService).getUser();
  const apiConfig: IApiConfig = inject(API_CONFIG);
  let configService = inject(ConfigService);
  const assessmentsService = inject(AssessmentsService);
  let assessments: any = assessmentsService.getAssessmentsRequest();
  let config = {
    env: apiConfig.environment,
    apiKey: apiConfig.apiKey,
    subscriptionKey: apiConfig.subscriptionKey,
    authToken: user?.id_token,
    assessmentToken: assessments ? assessments.assessmentsToken : null,
    progressBarTitle: assessments?.progressBarTitle ?? 'Assessment',
    summaryTitle: assessments?.summaryTitle ?? 'Summary',
    summaryDescription: assessments?.summaryDescription ?? '',
    redirectUrl: assessments?.redirectUrl,
  };
  configService.setConfig(config);
  return config;
}
